import * as React from "react";

import { Stack } from "@mui/material";
import { Box } from "@mui/system";

import Image from "../Image/Image";

import { useGiveHeartButton, GiveWithHeartButtonProps } from "./useGiveWithHeartButton";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { Lock } from "@/icons/outlined";

export const GiveWithHeartButton: React.FunctionComponent<React.PropsWithChildren<GiveWithHeartButtonProps>> = (
  props
) => {
  const { heartUrl } = useGiveHeartButton(props);

  const { t } = useTranslate();
  return (
    <DashboardButton
      type="submit"
      variant="filled"
      data-test="donate"
      vibe="brand"
      size="large"
      onClick={props.onSubmit}
      disabled={props.disabled}
      fullWidth
    >
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} sx={{ width: 1 }}>
        <Box component="span">
          {props.showProceedMessage ? t("common", "paymentMethod.button.proceedToPayment") : props.wording}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 0,
            flexShrink: 0,
          }}
        >
          {props.showProceedMessage ? (
            <Lock width={20} height={20} />
          ) : (
            <Image alt="heart" src={heartUrl} width={20} height={20} />
          )}
        </Box>
      </Stack>
    </DashboardButton>
  );
};
